import { Helmet } from "react-helmet-async";

export default function SEOHead({ title, description, noindex = false }) {
  const fullTitle = `${title} | Classroom`;
  const defaultDesc =
    "MEB müfredatına uygun, ilkokul öğrenciler için interaktif İngilizce eğitim platformu.";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDesc} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
}
